export const getAPIURL = (resourceURL, model, params) => {
  if (params == null) {
    params = {}
  }
  let url = window.App.getAPIUrl("api/private/content/assessment/")
  if (resourceURL.length) {
    url = `${url}${resourceURL}/`
  }

  const assessmentContext = window.App.request("get:assessment:context")
  if (!params.sid && assessmentContext.sid) {
    params.sid = assessmentContext.sid
  }

  if (!params.sid && model.get("step_id")) {
    params.sid = model.get("step_id")
  }

  if (params.sid != null) {
    params.perms = `step_${params.sid}`
  } else {
    console.error("error setting step ID on assessment URL params!")
  }

  if (params) {
    url = `${url}?${$.param(params)}`
  }

  return url
}
